/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-07-22 13:52:30
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-11-04 16:41:15
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/DatePicker/DatePicker.tsx
 */
import React, { ReactNode } from 'react';
import { DatePicker as OriginalPicker } from 'antd';
//import { controlSymbolFilter } from '../../../tools/helper';
import css from './css.less';
import FormItem from '@/src/components/Antd/FormItem/FormItem';
import { EnumFormItemStatus } from 'src/types/common/validation';
import moment from 'moment';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
interface IProps {
  className?;

  onChange?;
  value?;
  placeholder?;
  allowClear?;

  size?;
  autoFocus?;
  format?: string;
  disabledDate?;
  disabled?;

  error?: boolean;
  help?: string | ReactNode;
  storeDateFormat?: string;
}
const dateFormat = 'DD-MM-YYYY';
const Input = (props: IProps, ref) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    className,
    onChange,

    value,
    //importplaceholder,
    //allowClear,

    size,
    autoFocus,
    error,
    help,
    storeDateFormat,
    ...rest
  } = props;
  const textOnchange = (mDate, dataString) => {
    if (onChange) onChange(mDate, dataString);
  };

  return (
    <FormItem
      {...(error && {
        status: EnumFormItemStatus.error,
        help: help || getI18n('general.antd.DatePicker.item_help'),
      })}>
      <OriginalPicker
        className={`${css.inpuStyle} ${
          size === 'large' ? css.largeStyle : ''
        } ${className || ''} `}
        onChange={textOnchange}
        ref={ref}
        autoFocus={autoFocus}
        placeholder={'01-01-2021'}
        value={value ? moment(value, dateFormat) : null}
        size={size}
        format={storeDateFormat || dateFormat}
        {...rest}
      />
    </FormItem>
  );
};

const _OriginalPicker = (props) => {
  const {
    className,
    onChange,

    value,
    //importplaceholder,
    //allowClear,

    size,
    autoFocus,
    ref,
    storeDateFormat,
    ...rest
  } = props;
  const textOnchange = (mDate, dataString) => {
    if (onChange) onChange(mDate, dataString);
  };
  // console.log('value', value);
  // console.log('value1', value ? moment(value) : null);
  return (
    <OriginalPicker
      className={`${css.inpuStyle} ${size === 'large' ? css.largeStyle : ''} ${
        className || ''
      } `}
      onChange={textOnchange}
      ref={ref}
      autoFocus={autoFocus}
      placeholder={'01-01-2021'}
      value={value ? moment(value) : null}
      size={size}
      format={storeDateFormat || dateFormat}
      {...rest}
    />
  );
};
_OriginalPicker.RangePicker = OriginalPicker.RangePicker;
export { _OriginalPicker as OriginalPicker };
export default React.forwardRef(Input);
